// extracted by mini-css-extract-plugin
export default {"details":"accordion_details__CE4Te","summary":"accordion_summary__BS9h0","open":"accordion_open__lonoW","content":"accordion_content__B9gfr"};